import { Modal, Button } from 'semantic-ui-react';

type AnnotationsSaveModalProps = {
    open: boolean;
    onClose: () => void;
    handleSave: () => void;
};

function AnnotationsSaveModal({ open, onClose, handleSave }: AnnotationsSaveModalProps) {
    return (
        <Modal size="mini" open={open} onClose={onClose}>
            <Modal.Header>Save Annotations</Modal.Header>
            <Modal.Content>
                <p>Are you sure you want to save your changes?</p>
                <p>Previously made changes to Mappings and Import Table may be lost!</p>
            </Modal.Content>
            <Modal.Actions>
                <Button positive onClick={handleSave}>
                    SAVE
                </Button>
                <Button secondary onClick={onClose}>
                    CANCEL
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default AnnotationsSaveModal;
